import {Injectable} from '@angular/core';
import {fromEvent, map, Observable, startWith} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ScreenService {
    private smBreakpoint = 576; // Bootstrap sm breakpoint
    private mdBreakpoint = 768; // Bootstrap md breakpoint
    private lgBreakpoint = 992; // Bootstrap lg breakpoint

    constructor() {
    }

    /**
     * Verifica se a tela está abaixo do breakpoint SM (576px)
     */
    isBelowSm(): Observable<{ matches: boolean }> {
        return this.createMediaQuery(`(max-width: ${this.smBreakpoint - 1}px)`);
    }

    /**
     * Verifica se a tela está abaixo do breakpoint MD (768px)
     */
    isBelowMd(): Observable<{ matches: boolean }> {
        return this.createMediaQuery(`(max-width: ${this.mdBreakpoint - 1}px)`);
    }

    /**
     * Verifica se a tela está abaixo do breakpoint LG (992px)
     */
    isBelowLg(): Observable<{ matches: boolean }> {
        return this.createMediaQuery(`(max-width: ${this.lgBreakpoint - 1}px)`);
    }

    /**
     * Verifica se é mobile (abaixo de MD)
     */
    isMobile(): Observable<{ matches: boolean }> {
        return this.isBelowMd();
    }

    /**
     * Verifica se é tablet (entre MD e LG)
     */
    isTablet(): Observable<{ matches: boolean }> {
        return this.createMediaQuery(
            `(min-width: ${this.mdBreakpoint}px) and (max-width: ${this.lgBreakpoint - 1}px)`
        );
    }

    /**
     * Verifica se é desktop (acima de LG)
     */
    isDesktop(): Observable<{ matches: boolean }> {
        return this.createMediaQuery(`(min-width: ${this.lgBreakpoint}px)`);
    }

    /**
     * Cria um observable de media query
     */
    private createMediaQuery(query: string): Observable<{ matches: boolean }> {
        const mediaQuery = window.matchMedia(query);

        return fromEvent<MediaQueryList>(mediaQuery, 'change').pipe(
            startWith(mediaQuery),
            map((list: MediaQueryList) => ({matches: list.matches}))
        );
    }

    /**
     * Verifica se a tela atual está abaixo de um breakpoint específico
     */
    isBelowBreakpoint(breakpoint: number): boolean {
        return window.innerWidth < breakpoint;
    }

    /**
     * Retorna a largura atual da tela
     */
    getScreenWidth(): number {
        return window.innerWidth;
    }

    /**
     * Retorna a altura atual da tela
     */
    getScreenHeight(): number {
        return window.innerHeight;
    }
}

